import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    url_api: process.env.VUE_APP_URL_API || 'http://suporte.connectintegra.com.br:9191/oauth'
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
